import { Controller } from "@hotwired/stimulus";
import { application } from "src/stimulus/application";

// Site::PrefectureArea::HouseMakerSection::Component の Stimulus コントローラ。
// landIeul: useVisibilityCheck の visibleData() 相当。「もっと見る」で非表示リストの先頭 step 件を
// 表示リストへ移し、残りが無くなったらボタンとグラデーション帯を取り除く。
class SitePrefectureAreaHouseMakerSectionController extends Controller {
  static targets = ["visibleList", "invisibleList", "button", "clearArea"];
  static values = { step: Number };

  declare readonly visibleListTarget: HTMLElement;
  declare readonly invisibleListTarget: HTMLElement;
  declare readonly hasButtonTarget: boolean;
  declare readonly buttonTarget: HTMLButtonElement;
  declare readonly clearAreaTargets: HTMLElement[];
  declare readonly stepValue: number;

  showMore(): void {
    const step = this.stepValue || 10;
    const items = Array.from(this.invisibleListTarget.children).slice(0, step);
    items.forEach((item) => this.visibleListTarget.appendChild(item));

    if (this.invisibleListTarget.children.length > 0) return;

    if (this.hasButtonTarget) this.buttonTarget.remove();
    this.clearAreaTargets.forEach((el) => el.remove());
  }
}

application.register(
  "site--prefecture-area--house-maker-section",
  SitePrefectureAreaHouseMakerSectionController,
);
